import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const SurveyExplorer = lazy(() =>
  import(/* webpackChunkName: "SurveyExplorer" */ '../../components/survey_explorer/LoadSurveyExplorer')
);

export default function SurveyExplorerComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <SurveyExplorer {...props} />
    </Suspense>
  );
}
